import { POST } from '@/server/http';
import URLS from '@/server/urls';

export default async ({
    cates = [],
    filter = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.config.getMetaList, { cates, filter }, options);
    if (error) return { error, status };
    return content || {};
};
